import React from "react";

class BaseComponent<P, S> extends React.Component<P, S> {
    constructor(props: P) {
        super(props);
    }

    setStateValue(value: any, property: string, stateObj?: any | null) {
        const obj = stateObj ? stateObj : {};
        obj[property] = value;
        this.setState({ ...this.state, ...obj });
    }

    getValueSafe(obj: any, property: string) {
        return obj ? obj[property] : "";
    }
}

export default BaseComponent



